import AgendaCard from "~/components/organisms/AgendaCard/AgendaCard";

const Agenda = () => {
  return <AgendaCard />;
};

export default Agenda;
